import type { NumberSpeller } from './types'

// Marathi has an irregular word for every number 0–99.
const BELOW_100 = [
  'शून्य', 'एक', 'दोन', 'तीन', 'चार', 'पाच', 'सहा', 'सात', 'आठ', 'नऊ',
  'दहा', 'अकरा', 'बारा', 'तेरा', 'चौदा', 'पंधरा', 'सोळा', 'सतरा', 'अठरा', 'एकोणीस',
  'वीस', 'एकवीस', 'बावीस', 'तेवीस', 'चोवीस', 'पंचवीस', 'सव्वीस', 'सत्तावीस', 'अठ्ठावीस', 'एकोणतीस',
  'तीस', 'एकतीस', 'बत्तीस', 'तेहेतीस', 'चौतीस', 'पस्तीस', 'छत्तीस', 'सदतीस', 'अडतीस', 'एकोणचाळीस',
  'चाळीस', 'एक्केचाळीस', 'बेचाळीस', 'त्रेचाळीस', 'चव्वेचाळीस', 'पंचेचाळीस', 'सेहेचाळीस', 'सत्तेचाळीस', 'अठ्ठेचाळीस', 'एकोणपन्नास',
  'पन्नास', 'एक्कावन्न', 'बावन्न', 'त्रेपन्न', 'चोपन्न', 'पंचावन्न', 'छप्पन्न', 'सत्तावन्न', 'अठ्ठावन्न', 'एकोणसाठ',
  'साठ', 'एकसष्ट', 'बासष्ट', 'त्रेसष्ट', 'चौसष्ट', 'पासष्ट', 'सहासष्ट', 'सदुसष्ट', 'अडुसष्ट', 'एकोणसत्तर',
  'सत्तर', 'एकाहत्तर', 'बाहत्तर', 'त्र्याहत्तर', 'चौऱ्याहत्तर', 'पंच्याहत्तर', 'शहात्तर', 'सत्त्याहत्तर', 'अठ्ठ्याहत्तर', 'एकोणऐंशी',
  'ऐंशी', 'एक्क्याऐंशी', 'ब्याऐंशी', 'त्र्याऐंशी', 'चौऱ्याऐंशी', 'पंच्याऐंशी', 'शहाऐंशी', 'सत्त्याऐंशी', 'अठ्ठ्याऐंशी', 'एकोणनव्वद',
  'नव्वद', 'एक्क्याण्णव', 'ब्याण्णव', 'त्र्याण्णव', 'चौऱ्याण्णव', 'पंच्याण्णव', 'शहाण्णव', 'सत्त्याण्णव', 'अठ्ठ्याण्णव', 'नव्व्याण्णव'
]

// 100 alone is "शंभर"; otherwise hundreds join "शे": एकशे, दोनशे, … एकोणीसशे.
function hundreds(h: number, r: number): string {
  return h === 1 && r === 0 ? 'शंभर' : `${BELOW_100[h]}शे`
}

function below1000(n: number): string {
  const h = Math.floor(n / 100)
  const r = n % 100
  return [h ? hundreds(h, r) : '', r ? BELOW_100[r] : ''].filter(Boolean).join(' ')
}

function spell(n: number): string {
  if (n === 0) return BELOW_100[0]
  const parts: string[] = []
  const units: Array<[number, string]> = [[10_000_000, 'कोटी'], [100_000, 'लाख'], [1000, 'हजार']]
  let rest = n
  for (const [size, word] of units) {
    const q = Math.floor(rest / size)
    if (q) parts.push(`${spell(q)} ${word}`)
    rest %= size
  }
  if (rest) parts.push(below1000(rest))
  return parts.join(' ')
}

export const mr: NumberSpeller = {
  spell,
  // 1100–1999 are said in hundreds ("एकोणीसशे पंच्याऐंशी"); other years as plain numbers.
  year: (n) => (n >= 1100 && n < 2000
    ? [`${BELOW_100[Math.floor(n / 100)]}शे`, n % 100 ? BELOW_100[n % 100] : ''].filter(Boolean).join(' ')
    : spell(n)),
  rupees: 'रुपये'
}
